import { Component, ElementRef, Input, ViewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'vw-ai-chatbot-message',
    imports: [],
    templateUrl: './ai-chatbot-message.component.html',
    styleUrl: './ai-chatbot-message.component.scss'
})
export class AiChatbotMessageComponent {
  private _message: string = '';

  @Input()
  set message(value: string) {
    this._message = value;
    this.animateMessage(value);
  }

  get message(): string {
    return this._message;
  }

  animatedMessage: string = '';
  animationInterval: any;

  // Scroll to the bottom of the message container
  @ViewChild('scrollMe') private messageContainer!: ElementRef;
  scrollMessageToBottom(): void {
    setTimeout(() => {
      this.messageContainer.nativeElement.scroll({
        top: this.messageContainer.nativeElement.scrollHeight,
        behavior: 'smooth',
      });
    }, 100);
  }

  // Animate the message letter by letter
  animateMessage(message: string) {
    // Clear any existing animation
    if (this.animationInterval) {
      clearInterval(this.animationInterval);
    }

    let currentIndex = 0;
    this.animatedMessage = '';

    this.animationInterval = setInterval(() => {
      if (currentIndex < message.length) {
        this.animatedMessage += message[currentIndex];
        currentIndex++;
        this.scrollMessageToBottom();
      } else {
        clearInterval(this.animationInterval);
      }
    }, 30); // Adjust speed here (lower = faster)
  }
}
